import { render } from "./rank.vue?vue&type=template&id=8702bee8&scoped=true"
import script from "./rank.vue?vue&type=script&lang=js"
export * from "./rank.vue?vue&type=script&lang=js"

import "./rank.vue?vue&type=style&index=0&id=8702bee8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8702bee8"]])

export default __exports__